<ion-input [preferWheel]="true" type="text"  [label]="label" labelPlacement="floating" 
[placeholder]="!modelString ? label : ''"
    fill='outline' readonly (click)="openModal()" [value]="modelString"></ion-input>
<ion-modal #dateModal >
  <ng-template>
    <ion-content>
      <ion-toolbar>
        <ion-title>{{ label }}</ion-title>
      </ion-toolbar>
      <ion-datetime [min]="minDate"   [cancelText]="'Clear'" (ionCancel)="clearDate()" [preferWheel]="true"   [showDefaultButtons]="true"  [max]="maxDate" presentation="date" (ionChange)="onChangeDate($event)"></ion-datetime>
    </ion-content>
  </ng-template>
</ion-modal>
